export interface Cache<K, V> {
    get: (id: K, getValue: () => V) => V;
    clear: () => void;
}

export function createCache<K, V>(): Cache<K, V> {
    let cache: Map<K, V> = new Map();
    return {
        get(id: K, getValue: () => V) {
            if (cache.has(id)) {
                return cache.get(id)!;
            }
            const value = getValue();
            cache.set(id, value);
            return value;
        },
        clear() {
            cache = new Map();
        },
    };
}
